import React from "react";
import { Row, Col } from "react-bootstrap";
import aboutBg from "../../images/robot.gif";
import logo from "./../../images/icons/got.gif";
const About = () => {
  return (
    <div>
      <Row
        xs={1}
        md={3}
        className="my-2 d-flex justify-content-center align-items-center gy-4"
      >
        <Col>
          <h6>
            Hello I am Shahriar. I have a deep interest in web development. At
            first I built website for fun then I took it seriosuly. I have
            knowledge in html, css, bootstrap, javascript, react, firebase
            authentication, git, github, node.js, express.js, mongodb. Its not
            all. I am always hungry to learn new things.
          </h6>
          <br />
          <h2>Summary</h2>
          <h2 className="footer-border"></h2>
          <p>
            Self-motivated, looking for a role as a frontend web
            developer/junior web developer. Passionate about building
            first-class web applications. Aiming to be an accomplished
            full-stack web developer. So, Now want to work at the industry level
            where I can work with responsibility and can achieve the highest
            level. I believe under supervised seniors, I can give my utmost best
            for the company.
          </p>
        </Col>
        <Col>
          <img className="w-100 ps-5 ms-5" src={aboutBg} alt="" />
          {/* <img className="w-100 ps-5 ms-5"  src='https://www.bacancytechnology.com/main/img/chatbot-development/chatboat.gif' alt='..' width='300px' /> */}
        </Col>
      </Row>
      <div className="mt-5 pt-5 fixed-bottom">
        <h6 className="text-center mt-3">
        Copyright <i class="far fa-copyright"></i> {new Date().getFullYear()}{" "}
          by <span className="text-success">Shahriar</span> All Rights Reserved<img className="ms-1" src={logo} width="40px" alt="" />
        </h6>
      </div>
    </div>
  );
};

export default About;
